<template>
  <div class="box box-2 mt-4">
    <div class="d-flex justify-content-between">
      <div class="section-title">2. Detail of Incident</div>
      <div v-if="showToggle" class="mt-2">
        <som-button button-type="clear" color="primary" v-on:click.prevent="toggle">
          <som-icon name="icon-chevron-down" size="sm"></som-icon>
        </som-button>
      </div>
    </div>
    <som-collapse ref="collapse" :collapsed="collapsed">
      <div class="form-content max-width-40">
        <div ref="situation">
          <fieldset>
            <legend class="special-label w-100">Which of the following best describes the dangerous situation that you wish to report?</legend>
            <div class="radio-container" :class="{'is-invalid': detailsError.situation}">
              <div class="row">
                <div class="col">
                  <div v-for="situation in situations.slice(0, situations.length/2)" :key="situation" class="custom-control custom-radio">
                    <input type="radio" class="custom-control-input" name="situation" :id="situation" :value="situation" @click="chooseSituation" />
                    <label class="custom-control-label" :for="situation">{{situation}}</label>
                  </div>
                </div>
                <div class="col">
                  <div v-for="situation in situations.slice(situations.length/2)" :key="situation" class="custom-control custom-radio">
                    <input type="radio" class="custom-control-input" name="situation" :id="situation" :value="situation" @click="chooseSituation" />
                    <label class="custom-control-label" :for="situation">{{situation}}</label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <small v-if="detailsError.situation" class="form-text text-danger">This is a required field.</small>
        </div>
        
        <div ref="details" class="form-group mt-4">
          <label for="details">Additional Details</label>
          <textarea
            class="form-control"
            :class="{'is-invalid': detailsError.situationDetails}"
            id="details"
            :aria-describedby="detailsError.situationDetails ? 'details-help' : null"
            aria-placeholder="Who, What, When, Where"
            placeholder="Who, What, When, Where"
            :maxlength="DETAILS_MAX_LENGTH"
            v-model="situationDetails"
          ></textarea>
          <div class="d-flex flex-row justify-content-between">
            <div>
              <small id="details-help" v-if="detailsError.situationDetails" class="form-text text-danger">This is a required field.</small>
            </div>
            <div class="text-count">{{situationDetails.length}}/{{DETAILS_MAX_LENGTH}}</div>
          </div>
        </div>
        <div class="form-group">
          <label for="file-upload">Include a photo. <span class="label-optional">Optional</span></label>
          <file-uploader ref="fileInput" input-id="file-upload" />
        </div>

        <div class="mt-4 d-flex justify-content-center">
          <som-button color="primary" v-on:click.prevent="continueFromStep2">Continue</som-button>
        </div>
      </div>
    </som-collapse>
  </div>
</template>

<script>
import FileUploader from './FileUploader';

const SITUATIONS = [
  'Alcohol',
  'Assault',
  'Bullying',
  'Cyberbullying',
  'Child Abuse',
  'Dating Violence',
  'Domestic Violence',
  'Drugs',
  'Explosives',
  'Fighting',
  'Guns',
  'Kidnapping / Attempted Kidnapping',
  'Planned Fights',
  'Planned School Attack',
  'Self-harm',
  'Sexting',
  'Sexual Assault / Misconduct / Exploitation',
  'Stalking',
  'Stealing',
  'Suicide Threats',
  'Threats',
  'Vandalism',
  'Weapons Possession',
  'Other'
];


export default {
  name: 'TipForm',
  components: {
    FileUploader,
  },
  props: {
    collapsed: Boolean,
    showToggle: Boolean,
    toggle: Function,
    continue: Function,
  },
  data() {
    return {
      situations: SITUATIONS,
      DETAILS_MAX_LENGTH: 500,

      // Details
      situation: null,
      situationDetails: '',
      files: [],
      detailsError: {},
    }
  },
  methods: {
    show() {
      this.$refs.collapse.show();
    },
    hide() {
      this.$refs.collapse.hide();
    },
    continueFromStep2() {
      let hasError = false;
      this.detailsError = {};

      if (!this.situation) {
        hasError = true;
        this.$refs.situation.scrollIntoView();
        this.detailsError.situation = true;
      }

      if (!this.situationDetails) {
        if (!hasError) {
          // Scroll to error only if another error hasn't been found yet
          this.$refs.details.scrollIntoView();
        }
        hasError = true;
        this.detailsError.situationDetails = true;
      }

      if (!hasError) {
        const image = this.$refs.fileInput.getImage();
        this.continue({
          type: this.situation,
          details: this.situationDetails,
          imageData: image.data,
          imageExt: image.ext,
        });
      }
    },

    chooseSituation(event) {
      this.situation = event.target.value;
    },
  },

  updated() {
    if (this.updateFocusElement) {
      this.$refs[this.updateFocusElement] && this.$refs[this.updateFocusElement].focus();
      this.updateFocusElement = null;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .selected-school-box {
    display: flex;
    flex-direction: 'row';
  }

  .selected-school-content {
    flex: 1;
  }

  .header-box {
    margin: 0 auto;
  }

  .logo-image {
    width: 100%;
    max-width: 16rem;
    height: auto;
  }

  .subtitle {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 600px) {
    .subtitle {
      font-size: 1rem;
    }
  }

  .bold {
    font-weight: bold;
  }

  .box {
    background-color: white;
  }

  .max-width-30 {
    max-width: 30rem;
  }

  .max-width-40 {
    max-width: 40rem;
  }

  .form-content {
    padding: 2rem;
    padding-top: 0;
    margin: 0 auto;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .section-title {
    font-family: Montserrat,sans-serif;
    font-weight: 700;
    line-height: 1.1;
    font-size: 1.375rem;
    letter-spacing: .1px;
    padding: 1rem;
    margin: 0;
    color: rgb(52, 118, 163);
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (max-width: 600px) {
    .section-title {
      font-size: 1.2rem;
    }
  }

  .special-label {
    text-align: center;
    padding: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgb(236, 236, 236);
  }

  textarea {
    height: 8rem;
  }

  textarea,
  select,
  input {
    font-size: 0.875rem;
  }

  textarea::placeholder {
    color: #aaa;

  }

  .message {
    margin: 0 auto;
  }

  .align-center {
    margin: 0 auto;
  }

  .border-top {
    border-top: 1px solid rgb(29, 25, 25);
  }

  .border-top-light {
    border-top: 1px solid rgb(236, 236, 236);
  }

  .text-bold {
    font-weight: bold;
  }

  .text-count {
    font-size: 0.875rem;
  }

  .enter-school-information-manually {
    margin-bottom: 1rem;
  }

  .label-optional {
    font-size: 0.6rem;
    color: rgb(110, 110, 110);
    margin-left: 0.25rem;
  }

  .radio-container {
    padding: 0.5rem 1rem;
  }

  .radio-container.is-invalid {
    border-radius: .25rem;
    border: 1px solid #b80000;
  }
</style>